import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DashboardBrand from './DashboardBrand';
import MenuContent from './MenuContent';
import OptionsMenu from './OptionsMenu';
import { useAuth } from '../../hooks/use-auth';

const drawerWidth = 260;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {
  const auth = useAuth();

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'flex' },
        flexDirection: 'column',
        height: '100dvh',
        [`& .${drawerClasses.paper}`]: {
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'background.paper',
          backgroundImage: 'none',
          borderRight: 'none',
          boxShadow: (theme) =>
            theme.palette.mode === 'light'
              ? 'inset -1px 0 0 rgba(15, 23, 42, 0.04)'
              : 'none',
        },
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 2.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <DashboardBrand />
      </Box>
      <Box sx={{ flex: 1, overflowY: 'auto', py: 1 }}>
        <MenuContent />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1.5,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.default',
        }}
      >
        <Avatar
          sizes="small"
          alt={`${auth?.user?.name}`}
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        />
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {`${auth?.user?.name}`}
          </Typography>
          {/* <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {auth?.user?.email}
          </Typography> */}
        </Box>
        <OptionsMenu />
      </Stack>
    </Drawer>
  );
}
